import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'txp-select-check-all',
  templateUrl: './select-check-all.component.html',
  styleUrls: ['./select-check-all.component.scss'],
  standalone: true,
  imports: [MatCheckbox],
})
export class SelectCheckAllComponent {
  @Input() model: UntypedFormControl;
  @Input() values = [];
  @Input() text = 'Select All';
  @Input() disabled: boolean = false;
  @Output() allSelected = new EventEmitter<boolean>();

  isChecked(): boolean {
    const modelValue = this.model?.value;
    return (
      modelValue &&
      Array.isArray(modelValue) &&
      modelValue.length > 0 &&
      this.values?.length &&
      modelValue.length === this.values.length
    );
  }

  isIndeterminate(): boolean {
    const modelValue = this.model?.value;
    return !!(
      modelValue &&
      Array.isArray(modelValue) &&
      this.values?.length &&
      modelValue.length &&
      modelValue.length < this.values.length
    );
  }

  toggleSelection(change: MatCheckboxChange): void {
    if (change.checked) {
      this.model.setValue(this.values);
      this.model.markAsDirty();
      this.model.markAsTouched();
      this.allSelected.emit(true);
    } else {
      this.model.setValue([]);
      this.model.markAsDirty();
      this.model.markAsTouched();
      this.allSelected.emit(false);
    }
  }
}
